export enum TextAlign {
  Left = 'Left',
  Center = 'Center',
  Right = 'Right',
  Justify = 'Justify',
}
